<template>
  <div class="home">
    <Temp />
  </div>
</template>

<script>
import Temp from '@/components/Temp.vue'

export default {
  name: 'Home',
  components: {
    Temp
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
